var map = {
	"./SPNews-big.jpg": 132,
	"./achievement-big.jpg": 133,
	"./design-big.jpg": 134,
	"./handshake-big.jpg": 135,
	"./hardware-big.jpg": 136,
	"./inferno-big.jpg": 137,
	"./persona-big.jpg": 70,
	"./typing-big.jpg": 139
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 451;



//////////////////
// WEBPACK FOOTER
// ./src/photos ^\.\/.*\-big\.jpg$
// module id = 451
// module chunks = 0